import { useEffect, useState } from 'react'
import type { WidgetProps } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export type TemperatureWidgetProps = WidgetProps & {
  value: number | null
  onChange: (value: number | null | undefined) => void
}

export const TemperatureWidget = ({
  className,
  disabled,
  id,
  onChange,
  placeholder,
  readonly,
  required,
  value
}: TemperatureWidgetProps) => {
  const [temperature, setTemperature] = useState<number | null>(value)

  useEffect(() => {
    if (value === undefined && temperature === null) return
    if (value == null) {
      setTemperature(null)
    } else if (temperature == null) {
      setTemperature(value)
    }
  }, [value])

  useEffect(() => {
    if (Number.isNaN(temperature) || temperature === null) onChange(undefined)
    else onChange(temperature)
  }, [temperature])

  return (
    <Mtds.Grid>
      <Mtds.Flex className='w-full'>
        <div className='relative w-full'>
          <Mtds.Input
            aria-labelledby={`${id}_label`}
            className={`
              ${className}
              w-full
              pr-10
            `}
            disabled={disabled}
            id={id}
            min={-100}
            max={40}
            onChange={({ target }) =>
              setTemperature(target.value === '' ? null : Number(target.value))
            }
            placeholder={placeholder}
            readOnly={readonly}
            required={required}
            type='number'
            value={temperature ?? ''}
          />
          <span
            className='pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-sm'
            style={{ color: 'var(--mtds-color-text-default)' }}
          >
            °C
          </span>
        </div>
      </Mtds.Flex>
    </Mtds.Grid>
  )
}
